import { render, staticRenderFns } from "./wish_generate.vue?vue&type=template&id=5f00e197&scoped=true&"
import script from "./wish_generate.vue?vue&type=script&lang=js&"
export * from "./wish_generate.vue?vue&type=script&lang=js&"
import style0 from "./wish_generate.vue?vue&type=style&index=0&id=5f00e197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00e197",
  null
  
)

export default component.exports